import { createContext } from 'react';

export interface ShortcutContextType {
  showHelp: () => void;
  hideHelp: () => void;
  toggleHelp: () => void;
  isHelpVisible: boolean;
}

export const ShortcutContext = createContext<ShortcutContextType | undefined>(undefined);
